import { ajax } from '../index'

/**
 * 分类页 相关接口
 */
export default {
  // 获取分类商品review数据
  getCategoryProduct(dataObj: any) {
    return ajax.get('api', `/api/v1/product/list/${dataObj.categoryPath}`, dataObj)
  },

  // 获取分类商品review数据
  getCategoryReviews(dataObj: any) {
    return ajax.get('api', `/api/v1/review/category/${dataObj.categoryId}`, dataObj)
  },

  // 获取分类页面extra数据
  getCategoryExtra(categoryId: number | string) {
    return ajax.get('api', `/api/v1/category/extra/${categoryId}`, {})
  },

  // 获取New Arrivals数据
  getNewArrivals(categoryId: number | string) {
    return ajax.get('api', `/api/v1/recommended/products/${categoryId}`, {})
  }
}